<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading" :is-full-screen="true" />
                <section>
                    <div>
                    <div>Map Cluster</div>
                    <head>
                    <title>Marker Clustering</title>
                    </head>
                    <body>
                        <div id="map"></div>
                    </body>
                        <div ref="mapContainer" style="height: 400px;"></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import common_methods from "../../utils/common_methods"
// import PinElement from 'vue2-google-maps';
import { MarkerClusterer } from "@googlemaps/markerclusterer";


// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg',
//     libraries: 'places', // If needed
//   },
// });
export default ({
    name: 'MapClusterFinal',
    mixins: [common_methods],
    components: {
        VueElementLoading,
        MarkerClusterer
    },
    data() {
        return {
            isLoading: false,
            map: null,
            infoWindow: null,
            labels: null,
            markers: null,
            directionsService: null,
            directionsRenderer: null,
            locations:[
                { lat: -31.56391, lng: 147.154312 },
                { lat: -33.718234, lng: 150.363181 },
                { lat: -33.727111, lng: 150.371124 },
                { lat: -33.848588, lng: 151.209834 },
                { lat: -33.851702, lng: 151.216968 },
                { lat: -34.671264, lng: 150.863657 },
                { lat: -35.304724, lng: 148.662905 },
                { lat: -36.817685, lng: 175.699196 },
                { lat: -36.828611, lng: 175.790222 },
                { lat: -37.75, lng: 145.116667 },
                { lat: -37.759859, lng: 145.128708 },
                { lat: -37.765015, lng: 145.133858 },
                { lat: -37.770104, lng: 145.143299 },
                { lat: -37.7737, lng: 145.145187 },
                { lat: -37.774785, lng: 145.137978 },
                { lat: -37.819616, lng: 144.968119 },
                { lat: -38.330766, lng: 144.695692 },
                { lat: -39.927193, lng: 175.053218 },
                { lat: -41.330162, lng: 174.865694 },
                { lat: -42.734358, lng: 147.439506 },
                { lat: -42.734358, lng: 147.501315 },
                { lat: -42.735258, lng: 147.438 },
                { lat: -43.999792, lng: 170.463352 },
            ]
        }
    },
    mounted() {
        this.loadGoogleMapsScript().then(() => {
            this.initMap();
        });

        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
    },
    methods: {
        loadGoogleMapsScript() {
            console.log("11111111");
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDhJQ2sy_EA-1Cin40Hsxph0uKHfDCT_ko&callback`;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        initMap() {
            console.log("2222");
            // this.markerArray = [];

            // this.directionsService = new window.google.maps.DirectionsService();
            let { Map, InfoWindow } = window.google.maps.importLibrary("maps");
            let { AdvancedMarkerElement, PinElement } = window.google.maps.importLibrary("marker");

            this.map = new window.google.maps.Map(this.$refs.mapContainer, {
                zoom: 5,
                center: { lat: -28.024, lng: 140.887 },
                mapId: "DEMO_MAP_ID",
            });
            console.log("this.map", this.map);

            this.infoWindow = new window.google.maps.InfoWindow({
                content: "",
                disableAutoPan: true,
            });
            console.log("this.infoWindow", this.infoWindow);

            this.labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

            this.markers = this.locations.map((position, i) => {
            let label = this.labels[i % this.labels.length];
            // this.pinGlyph = new window.google.maps.marker.PinElement({
            //     glyph: this.label,
            //     glyphColor: "white",
            // });
            // console.log("this.pinGlyph", this.pinGlyph);

            // this.marker = new window.google.maps.marker.AdvancedMarkerElement({
            //     position,
            //     content: this.pinGlyph.element,
            // });

            //////////////
            let marker = new window.google.maps.Marker({
                position,
                label,
            });
                // console.log("label:- ", label);
                // console.log("this.map", this.map);
                // console.log("marker", marker);

                // markers can only be keyboard focusable when they have click listeners
                // open info window when marker is clicked
            marker.addListener("click", () => {

                this.infoWindow.setContent(label);
                this.infoWindow.open(this.map, marker);
            });

            return marker;
            //////////////////

            // markers can only be keyboard focusable when they have click listeners
            // open info window when marker is clicked
            // this.marker.addListener("click", () => {
            //     this.infoWindow.setContent(position.lat + ", " + position.lng);
            //     this.infoWindow.open(this.map, this.marker);
            // });
            // return this.marker;
        });
        // console.log("this.markers", this.markers);

        // Add a marker clusterer to manage the markers.

        // let tempObj = {
        //     algorithm?: Algorithm;
        //     map?: google.maps.Map;
        //     markers?: google.maps.Marker[];
        //     renderer?: Renderer;
        //     onClusterClick?: onClusterClickHandler;
        // }

        let t_mark=this.markers;
        let t_map=this.map
        console.log("t_mark", t_mark);

        // this.markerCluster = new MarkerClusterer({ t_map, t_mark });

        new MarkerClusterer({t_mark, t_map});

        // MarkerClusterer = new MarkerClusterer(this.markers, this.map );

            // return markerCluster
        },
    },
})
</script>

<style scoped>
 #map {
  height: 100%;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>